// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"ZIStyles__msignaturepad___3gtw7","m-signature-pad--body":"ZIStyles__m-signature-pad--body___3HP_M","m-signature-pad--footer":"ZIStyles__m-signature-pad--footer___2tK1A","description":"ZIStyles__description___35qF7","button":"ZIStyles__button___1x2jJ","clear":"ZIStyles__clear___2ZE1b","save":"ZIStyles__save___2_TZr","m-signature-pad":"ZIStyles__m-signature-pad___2sQvL","github":"ZIStyles__github___34Ih7","tag":"ZIStyles__tag___3V7PC","remove":"ZIStyles__remove___1AOpj"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/TaggedInput/CustomTaggedInput/ZipsInput/ZIStyles.scss
// module id = 4cbU
// module chunks = client